import { Box } from "@chakra-ui/react";
import { ReactComponent as FailureIcon } from "./failure.svg";
import { ReactComponent as SuccessIcon } from "./success.svg";
import { ReactComponent as WarningIcon } from "./warning.svg";
import IconOnBackground from "src/components/IconOnBackground";

export default function Icon({ icon, fill, type, bg, ...rest }) {
  if (bg == null && (type === "none" || type == null)) {
    return null;
  }

  switch (type) {
    case "success":
      bg = "primaryLight";
      icon = icon || SuccessIcon;
      fill = fill || "primary";
      break;
    case "failure":
      bg = "warningLight";
      icon = icon || FailureIcon;
      fill = fill || "warningBase";
      break;
    case "warning":
      bg = "warningLight";
      icon = icon || WarningIcon;
      fill = fill || "warningBase";
      break;
    case "unset":
      break;
    default:
      bg = bg || "primaryLight";
      icon = icon || SuccessIcon;
      fill = fill || "primary";
      break;
  }

  return (
    <Box {...rest}>
      <IconOnBackground bg={bg} fill={fill} icon={icon} />
    </Box>
  );
}
